import styled from "@emotion/native";
import Text from "../Text";
import { PointerIcon } from "myplan/components/Icon";

export const CONTAINER_PADDING_HORIZONTAL = 12;

export const Container = styled.View(
	{
		paddingHorizontal: CONTAINER_PADDING_HORIZONTAL,
		marginBottom: 35,
		flex: 1,
		// debug
		// borderColor: "red",
		// borderWidth: 1,
	},
	({ inline = false }: any) => {
		if (inline) {
			return {
				marginBottom: 0,
				paddingHorizontal: 0,
			};
		}
		return {};
	}
);

export const ScoreContainer = styled.View(
	{
		height: 46,
		zIndex: 1,
	},
	({ inline = false }: any) => {
		if (inline) {
			return {
				height: 20,
			};
		}
		return {};
	}
);

export const Score = styled.View(
	{
		position: "absolute",
		left: 0,
	},
	({ translateX, align, inline = false }: any) => {
		return {
			alignItems: align,
			paddingTop: inline ? 0 : 20, // allow space for label above pointer
			transform: [
				{
					translateX: isNaN(translateX) ? 0 : translateX,
				},
			],
		};
	}
);

export const ScoreLabel = styled(Text)({
	textAlign: "center",
	position: "absolute",
	top: 0,
	width: 200,
});

export const Pointer = styled(PointerIcon)(
	{
		marginTop: 8,
	},
	({ tally }: any) => {
		return {
			left: tally === 0 ? -26 : 0,
		};
	}
);

export const Graph = styled.View({
	flexDirection: "row",
	width: "100%",
	minHeight: 54,
	flex: 1,
});

export const Segment = styled.View({
	flex: 1,
	paddingHorizontal: 2,
});

export const SegmentBar = styled.View({
	height: 14,
});

export const SegmentTitle = styled(Text)(
	{
		marginTop: 7,
		height: 20,
	},
	({ inline }: any) => {
		if (inline) {
			return {
				fontSize: 10,
			};
		}
		return {};
	}
);

export const SegmentRange = styled(Text)(
	{
		height: 20,
	},
	({ inline }: any) => {
		if (inline) {
			return {
				fontSize: 13,
				lineHeight: 13,
			};
		}
		return {};
	}
);
